import React, { useState } from "react";
import emailjs from "emailjs-com";
import Popup from "./Popup";

function ChatBox() {
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [msgBox, setMsgBox] = useState(false);
  const [message, setMessage] = useState({
    fullName: "",
    email: "",
    msg: "",
  });

  const resetFields = () => {
    setMessage({
      fullName: "",
      email: "",
      msg: "",
    });
  };

  const toggleBold = () => {
    setIsBold(!isBold);
  };

  const toggleItalic = () => {
    setIsItalic(!isItalic);
  };

  const toggleMessageBox = () => {
    setMsgBox(!msgBox);
  };

  const makeBtnClick = () => {
    if (!message.fullName && !message.email && !message.msg) {
      alert("Please enter Valid Credentials");
    } else {
      sendEmail();
      toggleMessageBox();
    }
  };

  const sendEmail = () => {
    emailjs
      .send(
        "service_vxawzcl",
        "template_emuaplt",
        {
          to_name: "Mahin",
          from_name: message.fullName,
          reply_to: message.email,
          email: message.email,
          message: message.msg,
        },
        "-0ER8HWkbdbV7UwWV"
      )
      .then(
        (response) => {
          console.log("Email sent!", response.status, response.text);
        },
        (error) => {
          console.error("Email failed to send!", error);
        }
      );
    setMessage({
      fullName: "",
      email: "",
      msg: "",
    });
  };
  return (
    <>
      <div
        onClick={toggleMessageBox}
        className={`font-Arimo ${
          msgBox ? "bg-blue-600" : "bg-common-red"
        } hover:${
          msgBox ? "bg-blue-700" : "bg-red-700"
        } text-white w-40 text-xl font-semibold text-center p-2 rounded-t-md cursor-pointer`}
      >
        <button>
          <i class="fa-regular fa-envelope"></i> Send Mail
        </button>
      </div>
      {msgBox && (
        <div className="animate-slide-in delay-1000 z-30 absolute vs:right--20 bottom-10 ts:right-10 max-w-md mx-auto bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div className="mb-4 z-30 ">
            <label
              className="block vs:w-[250px] sm:w-[350px] ts:w-[400px] text-gray-700 text-sm font-bold mb-2 z-30"
              htmlFor="message"
            >
              <div className="flex justify-between">
                <p className="font-semibold text-lg">Enter Your Message</p>
                <button
                  onClick={() => setMsgBox(false)}
                  className="hover:rotate-90  transition-all fa-regular fa-circle-xmark text-2xl hover:text-blue-600 text-red-600 font-semibold"
                ></button>
              </div>
            </label>
            <div className="flex mb-2 gap-1">
              <button
                className={`${isBold ? "bg-blue-500" : "bg-red-600"} hover:${
                  isBold ? "bg-blue-700" : "bg-red-700"
                } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${
                  isBold ? "font-black" : ""
                }`}
                type="button"
                onClick={toggleBold}
              >
                Bold
              </button>
              <button
                className={`${isItalic ? "bg-blue-500" : "bg-red-600"} hover:${
                  isItalic ? "bg-blue-700" : "bg-red-700"
                } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${
                  isItalic ? "italic" : ""
                }`}
                type="button"
                onClick={toggleItalic}
              >
                Italic
              </button>
              <button
                onClick={resetFields}
                className={`${
                  !message.email && !message.fullName && !message.msg
                    ? "bg-slate-400"
                    : "bg-blue-500"
                } hover:${
                  !message.email && !message.fullName && !message.msg
                    ? "bg-slate-400 cursor-not-allowed"
                    : "bg-blue-700 cursor-pointer"
                } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
                disabled={!message.email && !message.fullName && !message.msg}
              >
                Reset
              </button>
            </div>
            <div>
              <input
                type="text"
                value={message.fullName}
                placeholder="Full Name"
                onChange={(e) =>
                  setMessage((prevData) => ({
                    ...prevData,
                    fullName: e.target.value,
                  }))
                }
                className="shadow my-2 w-full text-wrap appearance-none border rounded py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline "
                required
              />
              <input
                type="email"
                value={message.email}
                placeholder="Email"
                onChange={(e) =>
                  setMessage((prevData) => ({
                    ...prevData,
                    email: e.target.value,
                  }))
                }
                className="shadow my-2 w-full text-wrap appearance-none border rounded py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline "
                required
              />
              <textarea
                className={`my-2 shadow w-full h-[200px] text-wrap appearance-none border rounded py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline ${
                  isBold ? "font-bold" : ""
                } ${isItalic ? "italic" : ""}`}
                id="message"
                onInput={(e) =>
                  setMessage((prevData) => ({
                    ...prevData,
                    msg: e.target.value,
                  }))
                }
                placeholder="Enter your message"
                value={message.msg}
                required
              ></textarea>
            </div>
            {/* <div>
              <h1 className="text-sm text-slate-400">
                due to some issue email service wasn't working now its working.{" "}
              </h1>
              <h2 className="text-xs text-slate-400">
                Updated at: 14, dec - 6 PM
              </h2>
            </div> */}
          </div>
          <div className="flex items-center justify-between">
            <Popup makeBtnClick={makeBtnClick} message={message} />
          </div>
        </div>
      )}
    </>
  );
}

export default ChatBox;
